import { render } from "./MoneyGoingOutWidget.vue?vue&type=template&id=4cbf2ca0"
import script from "./MoneyGoingOutWidget.vue?vue&type=script&lang=js"
export * from "./MoneyGoingOutWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__